import { Inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, of, switchMap } from "rxjs";
import { DashboardService } from "../../services";
import { appEventActions } from "../app-event";
import { dashboardActions } from "./dashboard.action";

@Injectable()
export class DashboardEffects {
    constructor(
        private actions$: Actions,
        @Inject(DashboardService) private dashboardService: DashboardService,
    ) {}

    getAdminDashboardSummary$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(dashboardActions.getAdminDashboardSummary),
            switchMap(() =>
                this.dashboardService.getAdminDashboard().pipe(
                    switchMap((data) => {
                        return of(dashboardActions.setAdminDashboardSummary({ data }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    getAdminDashboardActivities$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(dashboardActions.getAdminDashboardActivities),
            switchMap(() =>
                this.dashboardService.getAdminDashboardActivities().pipe(
                    switchMap((data) => {
                        return of(dashboardActions.setAdminDashboardActivities({ data }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    getAdminFeesByStd$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(dashboardActions.getAdminFeesByStd),
            switchMap(() =>
                this.dashboardService.getAdminDashboardFeesByStd().pipe(
                    switchMap((data) => {
                        return of(dashboardActions.setAdminFeesByStd({ data }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    getAdminFeesPaymentTrend$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(dashboardActions.getAdminFeesPaymentTrend),
            switchMap(() =>
                this.dashboardService.getAdminDashboardFeesTrendByYear().pipe(
                    switchMap((data) => {
                        return of(dashboardActions.setAdminFeesPaymentTrend({ data }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    getAdminAdmByStd$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(dashboardActions.getAdminAdmByStd),
            switchMap(() =>
                this.dashboardService.getAdminDashboardAdmByStd().pipe(
                    switchMap((data) => {
                        return of(dashboardActions.setAdminAdmByStd({ data }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });
}
